import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEarLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 23,
	viewBox: "0 0 20 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.18295 23H19.3258C19.3258 23 16.7968 15.7936 11.0435 8.5C5.29012 1.20637 1.18295 0 1.18295 0C1.18295 0 0 4 0 12.5C0 16.9053 1.18295 23 1.18295 23Z",
		fill: "white"
	})
});
export default SvgEarLeft;
